import {Component} from '@angular/core';

@Component({
    selector: 'vui-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss']
})
export class LogoComponent {

}
